'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildParams(params) {
    return _qs2.default.stringify(params, { encode: false });
}

function buildUrl(url, querystring) {
    if (!querystring) {
        return url;
    }

    return url + '?' + querystring;
}

function cleanParams(otherParams) {
    if (typeof otherParams === 'string' && otherParams.charAt(0) === '?') {
        return otherParams.substring(1);
    }

    return otherParams;
}

function customizeSignIn(otherParams, paramsToBuild) {
    if (otherParams.includes('utm_campaign=applynow') || otherParams.includes('inviteId')) {
        // If user comes from clicking "Apply Now" or invitation url, we want to customize the sign in page
        paramsToBuild['he'] = encodeURIComponent('Apply to this property');
        paramsToBuild['sh'] = encodeURIComponent('Please sign in or create an account to securely apply.');
    } else if (otherParams.includes('utm_source=rachelPaymentInvite') || paramsToBuild.url.match('rental-manager%2Fproperties%2F.+%2Fpayments')) {
        paramsToBuild['he'] = encodeURIComponent('Continue to Payments');
        paramsToBuild['sh'] = encodeURIComponent('Please sign in to securely manage your rental payments.');
    }

    return paramsToBuild;
}

exports.default = {
    hotpads: {
        signInPage: function signInPage(toUrl, otherParams) {
            var params = _qs2.default.parse(cleanParams(otherParams));
            return buildUrl('/login', buildParams(_extends({
                escape: true,
                redirect: toUrl
            }, params)));
        },
        passwordResetPage: function passwordResetPage(toUrl, otherParams) {
            var params = _qs2.default.parse(cleanParams(otherParams));
            return buildUrl('/user/update-password', buildParams(_extends({
                escape: true,
                redirect: toUrl
            }, params)));
        }
    },

    zillow: {
        signInPage: function signInPage(toUrl, otherParams) {
            var paramsToBuild = { url: encodeURIComponent(toUrl + otherParams) };
            var params = buildParams(customizeSignIn(otherParams, paramsToBuild));
            return buildUrl('/user/acct/login/', params);
        },
        passwordResetPage: function passwordResetPage(toUrl, otherParams) {
            var params = buildParams({ url: encodeURIComponent(toUrl + otherParams) });
            return buildUrl('/myzillow/ChangePassword.htm', params);
        }
    },

    trulia: {
        signInPage: function signInPage(toUrl, otherParams) {
            return buildUrl('/rentallogin/r' + toUrl, cleanParams(otherParams));
        },
        passwordResetPage: function passwordResetPage(toUrl, otherParams) {
            return buildUrl('/rentallogin/r' + toUrl, cleanParams(otherParams));
        }
    }
};